export const MAIL_ADDRESSES = {
  SUPPORT: 'support@up-sider.com',
  PRESIDENT_CONCIERGE: 'concierge@president-card.com',
}
